import pagesNames from "../../constants/pages-names"

const ourJourneyPageDataAr = {
    header : {
        image : {
            name : "journey.jpg",
            alt : "Our Joureny wallpaper",
        }
    },
    mainTitle : "رحلتنا في مجال الممارسات البيئية والاجتماعية والحوكمة المؤسسية.",
    sectionOne : {
        borderBox : {
            title : "التوصيات الخاصة بالنموذج التشغيلي المستهدف",
            subtitle : "يعمل البنك وفق نموذج أعمال مبني على الممارسات العالمية الرائدة في مجال الممارسات البيئية والاجتماعية والحوكمة المؤسسية وعلى التوصيات الخاصة بالنموذج التشغيلي المستهدف.",
        },
        cards : [
            {
                title : "الحوكمة والقيادة"
            },
            {
                title : "إدارة المخاطر"
            },
            {
                title : "إعداد تقارير الممارسات البيئية والاجتماعية والحوكمة المؤسسية ومؤشرات الأداء الرئيسية"
            },
            {
                title : "التمويل المستدام"
            },
            {
                title : "العمليات التشغيلية"
            },
            {
                title : "المشاركة الخارجية"
            },
        ]
    },
    timeLine : {
        title : "رحلة البنك السعودي الأول على صعيد الممارسات البيئية والاجتماعية والحوكمة المؤسسية: مسيرة طويلة من الجهود المضنية",
        headers : ["2022-23", "2023-25", "2025-30", "2030-40", "2040 وما بعدها"],
        tabs : [
            {
                title : "زراعة مليون شجرة والشراكة مع مبادرة السعودية الخضراء",
                subtitle : "بناء القدرات",
                list : [
                    {
                        text : "وضع إطار عمل التمويل المستدام",
                        important : false,
                    },
                    {
                        text : "طرح المقترحات الخاصة بالتمويل والاستثمار المستدام",
                        important : false,
                    },
                    {
                        text : "بناء القدرات على مستوى جميع الأقسام بالبنك",
                        important : true,
                    },
                    {
                        text : "عقد الشراكات مع جهات خارجية لقياس خط الأساس",
                        important : false,
                    },
                    {
                        text : "الإعلان عن الاستراتيجية والطموحات",
                        important : false,
                    },
                    {
                        text : "عقد جلسات التوعية للعملاء",
                        important : false,
                    },
                    {
                        text : "تدشين استبيانات خطر الانتقال (TRQ) بالبنك",
                        important : false,
                    },
                ],
                image : {
                    name : "img-1.jpg",
                    alt : "Tab 1"
                }
            },
            {
                title : "أشكال التمويل والاستثمار المستدام بقيمة 34 مليار ريال سعودي",
                subtitle : "النمو واحتلال حصة بالسوق",
                list : [
                    {
                        text : "تحليل كامل للسيناريوهات",
                        important : false,
                    },
                    {
                        text : "تحقيق صافي الانبعاثات الصفري بناءً على توصيات مبادرة الهدف المستندة إلى العلم (SBTi)",
                        important : false,
                    },
                    {
                        text : "تحقيق المزيد من التطوير لمجموعة شاملة من حلول التمويل المستدام",
                        important : false,
                    },
                    {
                        text : "ضخ التمويلات الجريئة في حلول الممارسات البيئية والاجتماعية والحوكمة المؤسسية",
                        important : true,
                    },
                    {
                        text : "جمع البيانات من استبيانات خطر الانتقال (TRQ)",
                        important : false,
                    },
                    {
                        text : "وضع سياسات المخاطر",
                        important : false,
                    },
                    {
                        text : "الولوج إلى القطاعات الجديدة والناشئة",
                        important : false,
                    },
                    {
                        text : "إعداد التقارير استنادًا إلى توصيات فرقة العمل المعنية بالإفصاحات المالية المتصلة بالمناخ (TCFD)",
                        important : false,
                    },
                    {
                        text : "قيادة الفكر من خلال المنشورات الخارجية",
                        important : false,
                    },
                ],
                image : {
                    name : "img-2.jpg",
                    alt : "Tab 2"
                }
            },
            {
                title : "تحقيق المنجزات الرئيسية في مسيرة بلوغ صافي الانبعاثات الصفري",
                subtitle : "تضمين سياسات المخاطر",
                list : [
                    {
                        text : "الإفصاح العلني عن انبعاثات الكربون من الأنشطة التمويلية",
                        important : false,
                    },
                    {
                        text : "دمج الممارسات البيئية والاجتماعية والحوكمة المؤسسية في أعمالنا ووظائفنا",
                        important : true,
                    },
                    {
                        text : "مراجعة إطار عمل مخاطر الائتمان للأطراف الخارجية لدمج المعايير الخاصة بالممارسات البيئية والاجتماعية والحوكمة المؤسسية",
                        important : false,
                    },
                    {
                        text : "تحقيق إنجاز هائل في مجال التمويل المستدام",
                        important : false,
                    },
                    {
                        text : "الانضمام إلى تحالف غلاسكو المالي من أجل صافي انبعاثات صفري (GFANZ) وغير ذلك من الكيانات الرائدة في مجال الممارسات البيئية والاجتماعية والحوكمة المؤسسية",
                        important : false,
                    },
                    {
                        text : "اكتساب تقدير السوق باعتبار البنك أحد رواد مجال الممارسات البيئية والاجتماعية والحوكمة المؤسسية",
                        important : false,
                    },
                ],
                image : {
                    name : "img-3.jpg",
                    alt : "Tab 3"
                }
            },
            {
                title : "تحقيق صافي انبعاثات صفري في عملياتنا التشغيلية وغير ذلك من المنجزات في مجال الانبعاثات",
                subtitle : "خفض البصمة الكربونية",
                list : [
                    {
                        text : "تحقيق صافي انبعاثات صفري في العمليات التشغيلية",
                        important : true,
                    },
                    {
                        text : "تنفيذ مسارات تستهدف خفض الانبعاثات بعيدًا عن القطاعات والعملاء أصحاب معدل انبعاثات الكربون الأعلى",
                        important : false,
                    },
                    {
                        text : "تطبيق سعر الكربون الداخلي",
                        important : false,
                    },
                    {
                        text : "الإفصاح عن حجم الانبعاثات من الأنشطة التمويلية بمحفظة البنك",
                        important : false,
                    },
                ],
                image : {
                    name : "img-4.jpg",
                    alt : "Tab 4"
                }
            },
            {
                title : "القياس وإعداد التقارير والتواصل والقيادة",
                subtitle : "",
                list : [
                    {
                        text : "مواصلة السعي نحو تحقيق الطموح المتمثل في نزع الكربون من محفظة أعمال الأنشطة التمويلية",
                        important : false,
                    },
                    {
                        text : "التكيف باستمرار مع معايير الإفصاح الدولية",
                        important : false,
                    },
                    {
                        text : "تحديد منجزات سنوية توضح مستوى التقدم المحرز في جهود تحقيق الطموحات",
                        important : false,
                    },
                    {
                        text : "تحقيق صافي صفري في الانبعاثات الناتجة عن الأنشطة التمويلية بحلول عام 2060 أو قبله",
                        important : true,
                    },
                ],
                image : {
                    name : "img-5.jpg",
                    alt : "Tab 5"
                }
            },
        ],
        
    },
    flexViewSection : [
        {
            image : {
                name : "img-2.jpg",
                alt : "Light Cross the trees",
            },
            title : "Social Impact",
            subtitle : "Play a leading role to shape an inclusive and diverse society, positively impacting our stakeholders",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
        {
            image : {
                name : "img-5.jpg",
                alt : "a person using a laptop",
            },
            title : "Overarching Goal",
            subtitle : "Commitment towards a high standard of governance, driving integrity and responsibility in all decision-making.",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
        {
            image : {
                name : "img-4.jpg",
                alt : "A woman helps a child",
            },
            title : "Sustainability in Our Operations",
            subtitle : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
    ]
}

export default ourJourneyPageDataAr